import { store } from "@/store/store";
import axios from "axios";

const checkAuth = new Promise((resolve) => {
  store.commit("incrementCarregando", true);

  axios({
    withCredentials: true,
    method: "get",
    url: `${process.env.VUE_APP_APIURL}/user/testeauth`,
  })
    .then((res) => {
      store.commit("incrementCarregando", false);
      store.commit("incrementLogado", res.data);
    })
    .catch(() => {
      store.commit("incrementCarregando", false);
      resolve("Unauthorized");
    });
});
export default checkAuth;
